import { Button } from '@/shared/components/ui/button';
import { Trans, useLingui } from '@lingui/react/macro';
import { Link, useCanGoBack, useRouter } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

export function FieldLogVisitBackButton() {
  const { t } = useLingui();
  const router = useRouter();
  const canGoBack = useCanGoBack();

  return canGoBack ? (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="shrink-0 gap-1 px-1.5 sm:px-2"
      aria-label={t`Go back`}
      onClick={() => router.history.back()}
    >
      <ArrowLeft className="size-4" aria-hidden />
      <span className="hidden sm:inline">
        <Trans>Back</Trans>
      </span>
    </Button>
  ) : (
    <Button asChild variant="ghost" size="sm" className="shrink-0 gap-1 px-1.5 sm:px-2">
      <Link to="/field/today" aria-label={t`Go back`}>
        <ArrowLeft className="size-4" aria-hidden />
        <span className="hidden sm:inline">
          <Trans>Back</Trans>
        </span>
      </Link>
    </Button>
  );
}
